import { styled } from '@linaria/react';
import { fonts, primitives, semantic, shadow, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 358px;
  max-width: 100%;
  box-sizing: border-box;
  padding: ${space['space-300']} ${space['space-400']};
  border-radius: ${size.radius['radius-sm']};
  box-shadow: ${shadow.xs};
  background: ${semantic.bg.surfaceSubtle};
  color: ${semantic.text.primary};

  &[data-tone='positive'] {
    background: ${semantic.bg.positiveSubtle};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.positive};
    color: ${semantic.text.positive};
  }

  &[data-tone='info'] {
    background: ${semantic.bg.infoSubtle};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.info};
    color: ${semantic.text.info};
  }

  &[data-tone='warning'] {
    background: ${semantic.bg.warningSubtle};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.warning};
    color: ${semantic.text.warning};
  }

  &[data-tone='danger'] {
    background: ${semantic.bg.dangerSubtle};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.danger};
    color: ${semantic.text.danger};
  }
`;

export const IconFrame = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
`;

export const Message = styled.p`
  flex: 1 0 0;
  min-width: 0;
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  overflow-wrap: break-word;
`;

export const Label = styled.span`
  flex-shrink: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  white-space: nowrap;
`;

export const Divider = styled.span`
  align-self: stretch;
  flex-shrink: 0;
  width: ${size.stroke['stroke-default']};
  background: currentColor;
  opacity: 0.4;
`;

export const DismissButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid currentColor;
    outline-offset: ${space['space-050']};
    border-radius: ${size.radius['radius-xs']};
  }
`;
